import { h } from "vue";
import { ElNotification } from "#imports";

// Обычная кнопка в цветах Element Plus: ElButton — компонент, через #imports
// его не подключить, а стили тянуть ради одной кнопки незачем
const BUTTON_STYLE =
  "background: var(--el-color-primary); color: #fff; border: 0; border-radius: 4px;" +
  "padding: 6px 14px; font-size: 12px; cursor: pointer";

// Вышла новая версия сайта, а вкладка открыта со старой. Nuxt сам раз в 5 минут
// сверяет номер сборки (experimental.checkOutdatedBuildInterval в nuxt.config) и
// вызывает app:manifest:update. Молча перезагружать нельзя — можно потерять
// недописанную форму заказа или карточку товара. Поэтому:
//  * при следующем переходе по сайту страница грузится целиком, уже новой версией —
//    человек этого не замечает, он и так уходит со страницы;
//  * тем, кто долго сидит на одной странице (админка), — уведомление с кнопкой
export default defineNuxtPlugin((nuxtApp) => {
  let updateReady = false;
  const router = useRouter();

  nuxtApp.hooks.hook("app:manifest:update", () => {
    if (updateReady) return;
    updateReady = true;

    ElNotification({
      title: "Сайт обновился",
      message: h("div", [
        h("div", { style: "margin-bottom: 8px" }, "Обновите страницу, чтобы работать с новой версией."),
        h("button", { type: "button", style: BUTTON_STYLE, onClick: () => window.location.reload() }, "Обновить"),
      ]),
      type: "info",
      duration: 0,
      position: "bottom-right",
    });
  });

  router.beforeEach((to, from) => {
    // Первая загрузка страницы — не переход; дальше — полная загрузка вместо SPA-перехода
    if (!updateReady || !from.matched.length) return;
    window.location.assign(to.fullPath);
    return false;
  });
});
